import React from 'react';
import './sectionfive.css';
import path from '../../assets/path.svg';


export default function SectionFive() {
    return (
        <div data-aos='zoom-in-down' className='sectionFive__main'>
            <div className="sectionFive__container">
                <h2 data-aos='zoom-out-down'className="head__two">
                The values we live By
                </h2>
                <img src={path} alt="" />
                <p data-aos='fade-in' className="paragraph">
                These guiding principles fosters great relationships between our tutors, parents and students.
                </p>
            </div>
        </div>
    )
}
